import { Button } from "@loot-os/ui/components/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@loot-os/ui/components/dialog";

/** Boxed's chat rules (`CHAT_RULES`), with the brand taken out. */
const CHAT_RULES = [
  { title: "Be respectful", description: "Treat everyone with kindness and courtesy." },
  {
    title: "No spam or excessive messages",
    description: "Keep the chat clean and avoid flooding with repetitive content.",
  },
  {
    title: "No offensive language",
    description: "Avoid using profanity, hate speech, or discriminatory language.",
  },
  {
    title: "No self-promotion",
    description:
      "Refrain from promoting personal channels, websites, or services. Links are not allowed.",
  },
  { title: "Stay on topic", description: "Keep discussions relevant to the community and site." },
];

/**
 * The chat rules. With `onAgree` it is the gate a shopper passes before their first message
 * (boxed's accept-rules modal); without, a plain read.
 */
export function ChatRulesDialog({
  open,
  onOpenChange,
  onAgree,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onAgree?: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Chat rules</DialogTitle>
          <DialogDescription>
            Staff remove messages and mute players who break them.
          </DialogDescription>
        </DialogHeader>
        <ol className="grid list-decimal gap-3 pl-5 text-sm">
          {CHAT_RULES.map((rule) => (
            <li key={rule.title}>
              <span className="font-medium">{rule.title}.</span>{" "}
              <span className="text-muted-foreground">{rule.description}</span>
            </li>
          ))}
        </ol>
        <DialogFooter>
          {onAgree ? (
            <>
              <DialogClose render={<Button type="button" variant="outline" />}>Cancel</DialogClose>
              <Button
                type="button"
                onClick={() => {
                  onAgree();
                  onOpenChange(false);
                }}
              >
                I agree
              </Button>
            </>
          ) : (
            <DialogClose render={<Button type="button" />}>Got it</DialogClose>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
